const title = process.env.VUE_APP_TITLE;
const platformEnv = process.env.VUE_APP_PLATFORM;
import logoHider from '@/assets/logohider.png';
import logoDemi from '@/assets/logo-demi.png';
import logoQyzy from '@/assets/logo-qyzy.png';
import logoQyd from '@/assets/logo-qyd.png';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title,
      logoHider,
      platformEnv
    };
  },
  computed: {
    logoExpand() {
      if (platformEnv === 'demi') {
        return logoDemi;
      }
      if (platformEnv === 'qyzy') {
        return logoQyzy;
      }
      return logoQyd;
    }
  }
};